import React from "react";

function MainButton (props:any) {

    return (
        <div className="main-button" onClick={props.func}>
            {props.icon? <img src={props.icon} alt=""/>: ""}
            <span>{props.text}</span>
            {props.price ? <span>{props.price} USDT</span>: ""}
        </div>
    )
}

export default MainButton